import React from 'react'
import { TextField } from '@material-ui/core'

const TextInput = (props) => {
  return (
    <TextField
      fullWidth={props.fullWidth}
      label={props.label}
      margin="dense"
      multiline={props.multiline}
      required={props.required}
      rows={props.rows}
      value={props.value}
      type={props.type}
      onChange={props.onChange}
      onKeyDown={props.onKeyDown}
      disabled={props.disabled}
      placeholder={props.placeholder}
      inputProps={{
        readOnly: props.readOnly || false,
      }}
    />
  )
}
export default TextInput
